// settings
import api from './utils/api';

class SettingsService {
  async findAll() {
    const result = await api.get('/settings');

    return result.data;
  }

  async update(data) {
    const result = await api.put('/settings', data);
    return result.data;
  }
}

export default new SettingsService();
